import { Box, Container, Typography, Stack } from '@mui/material';
import type { ReactNode } from 'react';

interface HeroSectionProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  variant?: 'default' | 'gradient';
}

export const HeroSection = ({
  title,
  subtitle,
  children,
  variant = 'default',
}: HeroSectionProps) => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background:
          variant === 'gradient'
            ? 'linear-gradient(135deg, #1C90D9 0%, #20C0DE 100%)'
            : 'transparent',
        color: variant === 'gradient' ? 'white' : 'inherit',
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={3} alignItems="center" textAlign="center">
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                opacity: 0.9,
                maxWidth: 700,
                lineHeight: 1.6,
              }}
            >
              {subtitle}
            </Typography>
          )}
          {children && <Box sx={{ mt: 2 }}>{children}</Box>}
        </Stack>
      </Container>
    </Box>
  );
};
